/**
 * Created by Ning Jiang on 3/15/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {TeslaServerDataParser} from "../TeslaServerDataParser";

export class TeslaParsedGameData extends SpinParsedGameData {

    private readonly _bonusSymbolTriggered:boolean;
    private readonly _wildSymbol:string;
    private readonly _totalSpinWinnings:number;
    private readonly _extraFreespinRewarded:any;
    private readonly _wildsCollected:number[];
    private readonly _dischargeWild:boolean;
    private _overlayWildsBeforeSpinStop:boolean[][];
    private readonly _freespinsPlayed:number;
    private _accumulatedRoundWin: number;

    public get bonusSymbolTriggered():boolean {
        return this._bonusSymbolTriggered;
    }

    public get dischargeWild():boolean {
        return this._dischargeWild;
    }

    public get wildSymbol():string {
        return this._wildSymbol;
    }

    public get totalSpinWinnings():number {
        return this._totalSpinWinnings;
    }

    public get extraFreespinRewarded():number {
        return this._extraFreespinRewarded;
    }

    public get freespinsPlayed():number {
        return this._freespinsPlayed;
    }

    public get wildsCollected():number[] {
        return this._wildsCollected;
    }

    public get overlayWildsBeforeSpinStop():boolean[][] {
        return this._overlayWildsBeforeSpinStop;
    }

    public get accumulatedRoundWin():number{
        return this._accumulatedRoundWin;
    }

    constructor(rawData:any, dataParser:TeslaServerDataParser) {
        super(rawData, dataParser);

        this._bonusSymbolTriggered = dataParser.parseBonusSymbolTriggered(rawData);
        this._wildSymbol = dataParser.parseWildSymbol(rawData);
        this._totalSpinWinnings = dataParser.parseTotalSpinWinnings(rawData);
        this._extraFreespinRewarded = dataParser.parseExtraFreespinRewarded(rawData);
        this._freespinsPlayed = dataParser.parseFreespinsPlayed(rawData);
        this._wildsCollected = dataParser.parseWildsCollected(rawData);
        this._overlayWildsBeforeSpinStop = dataParser.overlayWildsBeforeSpinStop(rawData);
        this._dischargeWild = dataParser.parseDischargeWild(rawData);
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }
}